/**
 * Thrown by query functions when the API responded fine but the requested entity
 * does not exist. Lets the UI tell "this course doesn't exist" apart from
 * "the request failed", which need very different messages.
 */
export class NotFoundError extends Error {
  constructor(message = "Not found") {
    super(message);
    this.name = "NotFoundError";
  }
}

/**
 * `instanceof` alone is unreliable across bundle/realm boundaries, so fall back
 * to the name that the constructor above always sets.
 */
export function isNotFoundError(error: unknown): boolean {
  return error instanceof NotFoundError || (error instanceof Error && error.name === "NotFoundError");
}
